import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        { staticClass: "form", on: { submit: _vm.onSubmit } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
                [
                  _c("span", [_vm._v("Request to tableau user:")]),
                  _c(
                    "b",
                    { staticClass: "ml-2", style: { color: "#1a0dab" } },
                    [
                      _vm._v(
                        _vm._s(_vm.accessRequest.benefited || _vm.userTableau)
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
                [_c("h6", [_vm._v("Fecha límite para la solicitud")])]
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isAccessRequestEmpty,
                      expression: "!isAccessRequestEmpty",
                    },
                  ],
                  attrs: { xl: "4", lg: "4", md: "4", sm: "12", xs: "12" },
                },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Start date :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              dense: "",
                              size: "sm",
                              type: "date",
                              readonly: "",
                            },
                            model: {
                              value: _vm.accessRequest.created,
                              callback: function ($$v) {
                                _vm.$set(_vm.accessRequest, "created", $$v)
                              },
                              expression: "accessRequest.created",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { xl: "4", lg: "4", md: "4", sm: "12", xs: "12" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Request until :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              size: "sm",
                              type: "date",
                              min:
                                _vm.minDate &&
                                _vm.accessRequest.status === "REJECTED",
                            },
                            model: {
                              value: _vm.accessRequest.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.accessRequest, "endDate", $$v)
                              },
                              expression: "accessRequest.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isAccessRequestEmpty,
                      expression: "isAccessRequestEmpty",
                    },
                  ],
                  attrs: { xl: "4", lg: "4", md: "4", sm: "12", xs: "12" },
                },
                [
                  _c("b-row", [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "input-mini", attrs: { size: "sm" } },
                          [
                            _c(
                              "b-button-group",
                              { attrs: { size: "sm" } },
                              [
                                _c(
                                  VBtn,
                                  {
                                    attrs: {
                                      color: "secondary",
                                      rounded: "",
                                      outlined: "",
                                      small: "",
                                      dense: "",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.$refs.fileInput2.$el
                                          .querySelector("input[type=file]")
                                          .click()
                                      },
                                    },
                                  },
                                  [_vm._v("Attach"), _c("b-icon-paperclip")],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("b-form-file", {
                              ref: "fileInput2",
                              staticStyle: { display: "none" },
                              attrs: {
                                accept: _vm.ACCES_REQUEST_FILE_FORMAT.join(","),
                              },
                              on: { change: _vm.onFileChange },
                              model: {
                                value: _vm.inputUploadFile,
                                callback: function ($$v) {
                                  _vm.inputUploadFile = $$v
                                },
                                expression: "inputUploadFile",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-8" },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, hover: true } },
                          [
                            _c(
                              "b-thead",
                              [
                                _c(
                                  "b-tr",
                                  [_c("b-th", [_vm._v("File")]), _c("b-th")],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(_vm.files, function (file, index) {
                                return _c(
                                  "b-tr",
                                  { key: index },
                                  [
                                    _c("b-td", [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openImage(
                                                file.fileLink
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(file.fileName))]
                                      ),
                                    ]),
                                    _c("b-td", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: { title: "Delete" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteFile(file)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                color: "blue",
                                                "font-size": "medium",
                                              },
                                            },
                                            [_vm._v("delete")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.dismissCountDown,
                        dismissible: "",
                        variant: "danger",
                      },
                      on: {
                        dismissed: function ($event) {
                          _vm.dismissCountDown = 0
                        },
                        "dismiss-count-down": _vm.countDownChanged,
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "File format is not supported, compress it into .zip instead"
                        ),
                      ]),
                      _c("b-progress", {
                        attrs: {
                          variant: "danger",
                          max: _vm.dismissSecs,
                          value: _vm.dismissCountDown,
                          height: "4px",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(
                    VTabs,
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(VTab, [_vm._v("General")]),
                      _c(VTab, [_vm._v("Connections")]),
                      _c(VTab, [_vm._v("Columns")]),
                    ],
                    1
                  ),
                  _c(
                    VTabsItems,
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        VTabItem,
                        [
                          _c("tab-general-view", {
                            attrs: {
                              item: _vm.item,
                              readonly: true,
                              isChangeRequest: _vm.ACCESS_TYPE_FLOW.ACCESS,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        [
                          _c("tab-connection-view", {
                            attrs: { item: _vm.item, readonly: true },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        [
                          _c("tab-column-view", {
                            attrs: {
                              item: _vm.item,
                              readonly: true,
                              isChangeRequest: _vm.ACCESS_TYPE_FLOW.ACCESS,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Request Reason"),
                  ]),
                  _c(VTextarea, {
                    attrs: {
                      outlined: "",
                      dense: "",
                      size: "sm",
                      rows: "3",
                      "max-rows": "3",
                      type: "text",
                      required: "",
                      readonly: !_vm.isAccessRequestEmpty,
                    },
                    model: {
                      value: _vm.accessRequest.commentary,
                      callback: function ($$v) {
                        _vm.$set(_vm.accessRequest, "commentary", $$v)
                      },
                      expression: "accessRequest.commentary",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isAccessRequestEmpty,
                  expression: "!isAccessRequestEmpty",
                },
              ],
            },
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("my_tasks.modals.response_reason"))),
                  ]),
                  _c(VTextarea, {
                    attrs: {
                      outlined: "",
                      dense: "",
                      small: "",
                      size: "sm",
                      rows: "3",
                      "max-rows": "3",
                      type: "text",
                      required: !_vm.isAccessRequestEmpty,
                    },
                    model: {
                      value: _vm.accessRequest.response,
                      callback: function ($$v) {
                        _vm.$set(_vm.accessRequest, "response", $$v)
                      },
                      expression: "accessRequest.response",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAccessRequestEmpty,
                  expression: "isAccessRequestEmpty",
                },
              ],
            },
            [
              _c("b-col", { attrs: { sm: "12", lg: "12" } }, [
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.onCancel(false)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons md-16" }, [
                          _vm._v("cancel"),
                        ]),
                        _vm._v("Cancel"),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "active ml-2",
                        attrs: {
                          type: "submit",
                          variant: "primary",
                          size: "sm",
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons md-16" }, [
                          _vm._v("send"),
                        ]),
                        _vm._v("Request"),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }